/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconSuccessSolidComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 408.576 408.576">
    <g>
    <g>
        <path d="M204.288,0C91.648,0,0,91.648,0,204.288s91.648,204.288,204.288,204.288s204.288-91.648,204.288-204.288 S316.928,0,204.288,0z M318.464,150.528l-130.56,129.536c-7.68,7.68-19.968,8.192-28.16,0.512L90.624,217.6 c-8.192-7.68-8.704-20.48-1.536-28.672c7.68-8.192,20.48-8.704,28.672-1.024l54.784,50.176L289.28,121.344 c8.192-8.192,20.992-8.192,29.184,0C326.656,129.536,326.656,142.336,318.464,150.528z" />
    </g>
</g>
  </Icon>
);
};

IconSuccessSolidComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDA4LjU3NiA0MDguNTc2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxnPgogICAgPGc+CiAgICAgIDxwYXRoIGQ9Ik0yMDQuMjg4LDBDOTEuNjQ4LDAsMCw5MS42NDgsMCwyMDQuMjg4czkxLjY0OCwyMDQuMjg4LDIwNC4yODgsMjA0LjI4OHMyMDQuMjg4LTkxLjY0OCwyMDQuMjg4LTIwNC4yODggUzMxNi45MjgsMCwyMDQuMjg4LDB6IE0zMTguNDY0LDE1MC41MjhsLTEzMC41NiwxMjkuNTM2Yy03LjY4LDcuNjgtMTkuOTY4LDguMTkyLTI4LjE2LDAuNTEyTDkwLjYyNCwyMTcuNiBjLTguMTkyLTcuNjgtOC43MDQtMjAuNDgtMS41MzYtMjguNjcyYzcuNjgtOC4xOTIsMjAuNDgtOC43MDQsMjguNjcyLTEuMDI0bDU0Ljc4NCw1MC4xNzZMMjg5LjI4LDEyMS4zNDQgYzguMTkyLTguMTkyLDIwLjk5Mi04LjE5MiwyOS4xODQsMEMzMjYuNjU2LDEyOS41MzYsMzI2LjY1NiwxNDIuMzM2LDMxOC40NjQsMTUwLjUyOHoiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPg==";
IconSuccessSolidComponent.Content = `<svg viewBox="0 0 408.576 408.576" xmlns="http://www.w3.org/2000/svg">
  <g>
    <g>
      <path d="M204.288,0C91.648,0,0,91.648,0,204.288s91.648,204.288,204.288,204.288s204.288-91.648,204.288-204.288 S316.928,0,204.288,0z M318.464,150.528l-130.56,129.536c-7.68,7.68-19.968,8.192-28.16,0.512L90.624,217.6 c-8.192-7.68-8.704-20.48-1.536-28.672c7.68-8.192,20.48-8.704,28.672-1.024l54.784,50.176L289.28,121.344 c8.192-8.192,20.992-8.192,29.184,0C326.656,129.536,326.656,142.336,318.464,150.528z"/>
    </g>
  </g>
</svg>`;

const IconSuccessSolid = styled(IconSuccessSolidComponent)``;

export default IconSuccessSolid;
